
export const ObjectGroupSettlementOption = {
  TWO_SETTLEMENTS: "TWO_SETTLEMENTS",
  ONE_SETTLEMENT_COMMISSION_AFTER_ARRIVAL: "ONE_SETTLEMENT_COMMISSION_AFTER_ARRIVAL",
  ONE_SETTLEMENT_COMMISSION_AFTER_DEPARTURE: "ONE_SETTLEMENT_COMMISSION_AFTER_DEPARTURE"
}
